var _title, _polygon, _polygon2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCss = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "437.29px",
    height: "491.728px",
    viewBox: "85.5 210.272 437.29 491.728",
    enableBackground: "new 85.5 210.272 437.29 491.728",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "CSS3 Logo")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1572B6",
    points: "128.668,652.845 89.21,210.272 522.79,210.272 483.29,652.775 305.735,702 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#33A9DC",
    points: "306,664.375 449.474,624.599 483.229,246.459 306,246.459 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M167.739,293.569l-0.308,54.766H390.34l-0.08,35.375H167.203l-0.161,54.766h222.909l-0.293,62.462  l-84.061,29.75l-83.639-29.75l0.063-27.087h-54.765l-0.251,65.719l138.353,49.289l138.877-49.289l0.467-98.873l0.141-19.834  l0.568-127.292L167.739,293.569L167.739,293.569z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCss, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/css.91679c7d.svg";
export { ForwardRef as ReactComponent };